import gql from 'graphql-tag';

const auctionAccessBlackListsQuery = gql`
  query auctionAccessBlackListsQuery(
    $auctionAccessNumber: String
    $size: Int
    $offset: Int
  ) {
    auctionAccessBlackLists(
      auctionAccessNumber: $auctionAccessNumber
      offset: $offset
      size: $size
    ) {
      id
      auctionAccessNo
      expirationDate
      notes
      createdAt
      status
    }
  }
`;

export default auctionAccessBlackListsQuery;
